// @flow
import { httpGet } from '~/core/api/helpers/helpers.api';
import url from 'url';

export function getHeatingHistory(
    id: string,
    start: Date,
    end: Date,
    timeUnit?: ?string,
    rate?: ?number
): Promise<Response> {
    const heatingHistoryUrl = url.format({
        pathname: `/history/heating/${id}`,
        query: {
            start: start.valueOf(),
            end: end.valueOf(),
            timeUnit: timeUnit,
            rate: rate,
            operation: 'AVG'
        }
    });

    return httpGet(heatingHistoryUrl);
}



// WEBPACK FOOTER //
// ./src/core/api/history/history.api.js